import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { OperatorOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/OperatorOperandValueImpl";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
// import ValidatedExpOperator = Expression.Domain.ValidatedExpOperator;
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;

export class ArgumentOperandIdentityImpl {
  constructor(expValueCategory, expValueType, multiple, expOperator, expArgumentOperand, expArgumentOperandGroup, restrictToFunctionInput) {
    _defineProperty(this, "expValueCategory", void 0);
    _defineProperty(this, "expValueType", void 0);
    _defineProperty(this, "multiple", void 0);
    _defineProperty(this, "key", void 0);
    _defineProperty(this, "expOperator", void 0);
    _defineProperty(this, "expArgumentOperand", void 0);
    _defineProperty(this, "expArgumentOperandGroup", void 0);
    _defineProperty(this, "restrictToFunctionInput", void 0);
    _defineProperty(this, "isPreferredDefault", void 0);
    this.expValueCategory = expValueCategory;
    this.expValueType = expValueType;
    this.multiple = multiple;
    this.expOperator = expOperator;
    this.expArgumentOperand = expArgumentOperand;
    this.expArgumentOperandGroup = expArgumentOperandGroup;
    this.restrictToFunctionInput = restrictToFunctionInput;
    /*
     * This calculation may be more complex in the future, possibly by having the argument operand declare that it is to
     * be used as a default specifically.
     */
    this.isPreferredDefault = this.expArgumentOperand.defaultCategoryID === this.valueCategoryID;
    this.key = ArgumentOperandIdentityKeyImpl.fromValues(expValueCategory.id, expValueType.id, multiple, expArgumentOperand.name, this.restrictToFunctionInput);
  }
  get valueCategoryID() {
    return this.expValueCategory.id;
  }
  get valueTypeID() {
    return this.expValueType.id;
  }
  get operandName() {
    return this.expArgumentOperand.name;
  }
  get label() {
    if (this.restrictToFunctionInput) {
      return AbReactResources.expression_formula_symbol();
    }
    return this.expArgumentOperand.categoryLabelAlias ?? this.expValueCategory.label;
  }
  get selectorLabel() {
    if (this.restrictToFunctionInput) {
      return AbReactResources.expression_formula_symbol();
    }
    return this.expArgumentOperand.categoryLabelAlias ?? this.expValueCategory.selectorLabel ?? this.expValueCategory.label;
  }
  compareTo(other) {
    let sort = 0;
    let k1 = this.key.toString();
    let k2 = other.key.toString();
    if (k1 !== k2) {
      sort = k1 > k2 ? 1 : -1;
    }
    return sort;
  }
  equals(operandIdentity) {
    return this.key.equals(operandIdentity.key);
  }
  represents(operandValue) {
    let represents = false;
    const valueCategoryID = operandValue.valueCategoryID;
    const operandName = operandValue.operandName;
    if (valueCategoryID && operandName && operandValue.valueTypeIDs) {
      const isFunction = OperatorOperandValueImpl.isInstance(operandValue) && operandValue.isFunction;
      for (let vt of operandValue.valueTypeIDs.toArray()) {
        if (ArgumentOperandIdentityKeyImpl.fromValues(valueCategoryID, vt, operandValue.multiple, operandName, isFunction).equals(this.key)) {
          represents = true;
        } else if (this.valueTypeID === Expression.Domain.Constants.VALUE_TYPE_WILDCARD_ANY && operandValue.multiple === this.multiple && operandName === this.operandName) {
          represents = true;
        }
        if (represents) {
          break;
        }
      }
    }
    return represents;
  }
}
class ArgumentOperandIdentityKeyImpl {
  constructor(key) {
    _defineProperty(this, "_key", void 0);
    this._key = key;
  }
  static fromValues(valueCategoryID, valueTypeID, multiple, operandName, isFunction) {
    return new ArgumentOperandIdentityKeyImpl(`${isFunction ? "function-" : ""}${valueCategoryID}-${valueTypeID}${multiple ? "[]" : ""}-${operandName}`);
  }
  get key() {
    return this._key;
  }
  toString() {
    return this._key;
  }
  equals(other) {
    const otherKey = typeof other === "string" ? other : other.key;
    return this.key === otherKey;
  }
}
//# sourceMappingURL=ArgumentOperandIdentityImpl.js.map
